import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import MaximizeReturnImage from './MaximizeReturnImage'

const copy = {
  title: `Maximize return on ad spend by leveraging real-time audiences powered by a unified profile`,
  description: `Use real-time data to deliver more relevant customer experiences and optimize budget by suppressing ads or messages the moment a customer takes action.`,
  list: [
    {
      title: `Target with precision, drive conversions with ease`,
      description: `Send targeted and predictive audiences directly to ad destinations such as TikTok, Google, and Facebook. Lookalikes, retargeting, exclusion lists—it’s all there, just waiting to improve your targeting and spike your return on ad spend.`,
    },
    {
      title: `Supporting a cookie-less future`,
      description: `Only a unified solution can enable marketers to leverage a single view of the customer to deliver on the promise of addressable advertising and ensure accurate audiences, even as support for cookies and other traditional identity mechanisms fades.`,
    },
  ],
}

const MaximizeReturn = () => {
  return (
    <SectionBase sticky={true} variant="2Col" reverse={true}>
      <Section.Contents>
        <Section.Sticky>
          <MaximizeReturnImage />
        </Section.Sticky>
      </Section.Contents>
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.title}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <StyledColumnTrack>
            {copy.list.map(({ title, description }, key) => (
              <CopyTextBase key={key}>
                <CopyText.Heading tag="h3" variant="h5">
                  {title}
                </CopyText.Heading>
                <CopyText.Description tag="p" variant="pMedium">
                  {description}
                </CopyText.Description>
              </CopyTextBase>
            ))}
          </StyledColumnTrack>
        </CopyTextBase>
      </Section.Copy>
    </SectionBase>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  margin-top: 48px;
`

export default MaximizeReturn
